/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import InsurancePoliciesidInsurancePolicy from './InsurancePoliciesidInsurancePolicy';

/**
 * The InsurancePoliciesIdBody model module.
 * @module model/InsurancePoliciesIdBody
 * @version v0.3
 */
export default class InsurancePoliciesIdBody {
  /**
   * Constructs a new <code>InsurancePoliciesIdBody</code>.
   * @alias module:model/InsurancePoliciesIdBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>InsurancePoliciesIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InsurancePoliciesIdBody} obj Optional instance to populate.
   * @return {module:model/InsurancePoliciesIdBody} The populated <code>InsurancePoliciesIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InsurancePoliciesIdBody();
      if (data.hasOwnProperty('insurance_policy'))
        obj.insurancePolicy = InsurancePoliciesidInsurancePolicy.constructFromObject(data['insurance_policy']);
    }
    return obj;
  }
}

/**
 * @member {module:model/InsurancePoliciesidInsurancePolicy} insurancePolicy
 */
InsurancePoliciesIdBody.prototype.insurancePolicy = undefined;

